import { format } from 'date-fns';
import Countdown from './Countdown';

interface TimeCountdownProps {
  expirationTime?: string;
}

const TimeCountdown: React.FC<TimeCountdownProps> = ({ expirationTime }) => {
  return (
    <div className="flex w-full flex-col items-start justify-between gap-2 rounded-lg border border-gray-300 bg-gray-50 px-4 py-3 text-gray-700 transition-colors hover:text-gray-900 md:flex-row md:items-center">
      <Countdown expirationTime={expirationTime} />

      <div className="w-full text-left text-sm md:text-right md:text-base">
        <span>
          {expirationTime
            ? format(new Date(expirationTime), "dd MMMM yyyy, HH:mm 'WIB'")
            : '-'}
        </span>
      </div>
    </div>
  );
};

export default TimeCountdown;
